"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contentTypeSchema = void 0;
const tslib_1 = require("tslib");
const fluent_json_schema_1 = tslib_1.__importDefault(require("fluent-json-schema"));
exports.contentTypeSchema = {
    prop: "contentType",
    schema: fluent_json_schema_1.default.string(),
};
//# sourceMappingURL=contentTypeSchema.js.map